import { SxProps } from "@mui/system";
import { CustomTooltipPlacement } from "../../../util/types";
import type { ThemeV2 } from "../../../util/types";

export const tooltipClassName = "custom-tooltip-content";

export const tooltipPosition = (placement: CustomTooltipPlacement): SxProps => {
  switch (placement) {
    case "top-start":
      return { bottom: "calc(100% + 8px)", left: 0 };
    case "top-end":
      return { bottom: "calc(100% + 8px)", right: 0 };
    case "bottom":
      return {
        top: "calc(100% + 8px)",
        left: "50%",
        transform: "translateX(-50%)",
      };
    case "bottom-start":
      return { top: "calc(100% + 8px)", left: 0 };
    case "bottom-end":
      return { top: "calc(100% + 8px)", right: 0 };
    case "left":
      return {
        right: "calc(100% + 8px)",
        top: "50%",
        transform: "translateY(-50%)",
      };
    case "right":
      return {
        left: "calc(100% + 8px)",
        top: "50%",
        transform: "translateY(-50%)",
      };
    case "top":
    default:
      return {
        bottom: "calc(100% + 8px)",
        left: "50%",
        transform: "translateX(-50%)",
      };
  }
};

export const tooltipWrapperSx = (): SxProps => ({
  position: "relative",
  display: "inline-flex",
  maxWidth: "100%",
  [`&:hover .${tooltipClassName}, &:focus-within .${tooltipClassName}, &:active .${tooltipClassName}`]:
    {
      opacity: 1,
      visibility: "visible",
    },
});

export const tooltipTriggerSx = (): SxProps => ({
  display: "inline-flex",
  maxWidth: "100%",
});

export const tooltipContentSx = (
  placement: CustomTooltipPlacement,
  disableInteractive: boolean,
  maxWidth: number | string,
  theme: ThemeV2,
): SxProps => ({
  ...tooltipPosition(placement),
  position: "absolute",
  zIndex: 1500,
  px: `${theme.tokens.spacing["2"]}px`,
  py: `${theme.tokens.spacing["1"]}px`,
  borderRadius: `${theme.tokens.shape.radius.sm}px`,
  maxWidth,
  width: "max-content",
  overflowWrap: "break-word",
  bgcolor: theme.tokens.color.text.primary,
  color: theme.tokens.color.text.inverse,
  fontSize: theme.tokens.typography.size.xs,
  lineHeight: theme.tokens.typography.lineHeight.normal,
  pointerEvents: disableInteractive ? "none" : "auto",
  opacity: 0,
  visibility: "hidden",
  transition: "opacity 150ms ease-in-out, visibility 150ms ease-in-out",
});
